import React, { useState } from "react";
import { Lightbulb, Keyboard, ArrowRight, CaretDown } from "@phosphor-icons/react";

export default function ModuleShell({
  title,
  subtitle,
  beginner,
  expert,
  score,
  nextLabel,
  onNext,
  actions,
  children,
  dense,
  related,
}) {
  const [tips, setTips] = useState(false);
  return (
    <div className={(dense ? "p-3 space-y-3" : "p-3 md:p-6 space-y-4") + " h-full flex flex-col min-h-0 gc-in"}>
      <div className="flex flex-col xl:flex-row xl:items-start justify-between gap-3 shrink-0">
        <div className="min-w-0">
          <div className="flex items-center gap-3">
            <h2 className="font-display text-xl md:text-2xl font-semibold">{title}</h2>
            {typeof score === "number" && (
              <span className="gc-score" title="Salud de este módulo">
                <i style={{ width: `${score}%` }} />
                <b className="tabular-nums">{score}</b>
              </span>
            )}
          </div>
          {subtitle && (
            <p className="text-sm mt-1 hidden sm:block" style={{ color: "var(--gc-muted)" }}>{subtitle}</p>
          )}
          {(beginner || expert) && (
            <>
              <button
                type="button"
                className="sm:hidden mt-2 text-[11px] uppercase tracking-wide flex items-center gap-1"
                style={{ color: "var(--gc-muted)" }}
                onClick={() => setTips((v) => !v)}
              >
                Consejo <CaretDown size={12} className={tips ? "rotate-180" : ""} />
              </button>
              <div className={"mt-2 flex-col sm:flex-row gap-2 text-xs " + (tips ? "flex" : "hidden sm:flex")}>
                {beginner && (
                  <div className="gc-card px-3 py-2 flex items-start gap-2 flex-1">
                    <Lightbulb size={14} className="shrink-0 mt-0.5 text-amber-500" />
                    <span style={{ color: "var(--gc-muted)" }}><b className="text-[11px] uppercase tracking-wide">Nuevo · </b>{beginner}</span>
                  </div>
                )}
                {expert && (
                  <div className="gc-card px-3 py-2 flex items-start gap-2 flex-1">
                    <Keyboard size={14} className="shrink-0 mt-0.5 text-sky-500" />
                    <span style={{ color: "var(--gc-muted)" }}><b className="text-[11px] uppercase tracking-wide">Experto · </b>{expert}</span>
                  </div>
                )}
              </div>
            </>
          )}
          {related}
        </div>
        <div className="flex flex-wrap gap-2 shrink-0 gc-hscroll">
          {onNext && nextLabel && (
            <button type="button" className="gc-btn gc-btn-primary h-10 px-4" onClick={onNext}>
              {nextLabel} <ArrowRight size={14} />
            </button>
          )}
          {actions}
        </div>
      </div>
      <div className="flex-1 min-h-0">{children}</div>
    </div>
  );
}

export function EmptyCraft({ title, body, cta, onCta, tips = [] }) {
  return (
    <div className="gc-card p-8 md:p-12 text-center max-w-xl mx-auto">
      <div className="font-display text-xl font-semibold">{title}</div>
      <p className="text-sm mt-2" style={{ color: "var(--gc-muted)" }}>{body}</p>
      {cta && (
        <button type="button" className="gc-btn gc-btn-primary h-11 px-5 mt-5" onClick={onCta}>{cta}</button>
      )}
      {tips.length > 0 && (
        <ul className="text-left text-xs mt-6 space-y-1.5 mx-auto max-w-sm" style={{ color: "var(--gc-muted)" }}>
          {tips.map((t) => <li key={t}>• {t}</li>)}
        </ul>
      )}
    </div>
  );
}

export function RelatedStrip({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className="flex gap-2 overflow-x-auto gc-hscroll mt-2 pb-0.5">
      {items.map((x) => (
        <button key={x.id} type="button" className="gc-chip shrink-0" onClick={x.onClick}>
          {x.img && (
            <img src={x.img} alt="" className="w-4 h-4 mr-1" style={{ imageRendering: "pixelated" }} />
          )}
          {x.label}
        </button>
      ))}
    </div>
  );
}
